import { render, staticRenderFns } from "./ShopTournamentMember.vue?vue&type=template&id=1d239026"
import script from "./ShopTournamentMember.vue?vue&type=script&lang=js"
export * from "./ShopTournamentMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports